<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div class="display-4 mb-4">
              iPhone、iPad - 安裝Shadowrocket(小火箭)使用教程
            </div>
            <p class="display-5">
              此应用已在国区下架，请使用非国区 Apple ID 下载。
            </p>
            <p class="display-5">
              我们为绑定非国区支付方式困难的订阅客户准备了下载帐户，请购买服务后点击下方按钮
              《获取外区 Apple ID》
            </p>
            <div
              v-if="accounts.length"
              style=' box-sizing: content-box; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", Helvetica, Tahoma, Arial, "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, SimSun, 宋体, Heiti, 黑体, sans-serif; font-size: 14px; color: rgb(57, 57, 57); font-weight: normal; font-style: normal; text-decoration: none; text-align: left; line-height: 1.5; text-indent: 0px;'
            >
              <hr />
              <div
                style="white-space: pre-wrap; overflow-wrap: break-word; user-select: none; cursor: text; will-change: opacity; padding-left: 0px; padding-right: 0px;"
              >
                <div
                  class="mb-4"
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(136, 153, 168); background-color: rgb(255, 255, 255); font-family: Arial;"
                      >如果您的iPhone或iPad已經有Shadowrocket(小火箭)APP，請直接跳到第6步驟操作，沒有的請從第1步開始操作。</span
                    ></span
                  >
                </div>
                <div
                  class="mb-4"
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(211, 61, 61); background-color: rgb(253, 195, 137);"
                      >★安裝前必看：</span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(211, 61, 61); background-color: rgb(253, 195, 137);"
                      >切記千萬不要在手機的「設置」登入，請按照以下步驟一步一步操作，操作有問題請聯繫客服協助處理，下載完成請務必登回自己的ID。</span
                    ></span
                  >
                </div>
                <div
                  v-for="i in 3"
                  :key="i"
                  class="mb-2"
                  style="font-weight: bold; font-size: 20px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(0, 0, 0); background-color: rgb(145, 234, 191);"
                      >★</span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(0, 0, 0); background-color: rgb(145, 234, 191);"
                      >切記：千萬不要在手機的「設置」登入，否則鎖機不負責。</span
                    ></span
                  >
                </div>
                <div style="font-weight: bold; font-size: 20px;">
                  <span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(211, 61, 61); background-color: rgb(255, 204, 203);"
                      >★</span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(211, 61, 61); background-color: rgb(255, 204, 203);"
                      >最後提醒一次：請一定一定一定要按照以下操作，每個畫面都有固定的操作，不要擅自操作。</span
                    ></span
                  >
                </div>
                <div>
                  <hr />
                </div>
                <div
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(115, 92, 255); background-color: rgb(218, 212, 255);"
                      >以上看完沒問題後，再開始往下操作</span
                    ></span
                  >
                </div>
                <div>
                  <hr />
                </div>
                <div
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >1.進入App Store</span
                    ></span
                  >
                </div>
                <div>
                  <div>
                    <img
                      alt=""
                      src="@/assets/images/ios/appstore.jpg"
                      style="width: 604px;"
                    />
                  </div>
                </div>
                <div
                  class="mb-2"
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >2.點擊右上角頭像，然後再往下滑到最底按登出，按登出後滑到最上面</span
                    ></span
                  >
                </div>
                <div>
                  <img
                    alt=""
                    src="@/assets/images/ios/logout.jpg"
                    style="width: 604px;"
                  />
                </div>

                <div
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >3.</span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >輸入Shadowrocket App的ID和密碼(ID密碼在下面)</span
                    ></span
                  >
                  <iframe
                    id="iframeContain"
                    name="iframeContain"
                    seamless
                    scrolling="yes"
                    :src="appleinfo"
                  >
                    您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
                  </iframe>
                  <div>
                    <img
                      alt=""
                      src="@/assets/images/ios/password.jpg"
                      style="width: 604px;"
                    />
                  </div>
                </div>
                <div style="font-weight: bold; font-size: 20px;">
                  <span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(0, 0, 0); background-color: rgb(145, 234, 191);"
                      >特別注意：</span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(0, 0, 0); background-color: rgb(145, 234, 191);"
                      >登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                    ></span
                  >
                </div>

                <div style="font-weight: bold; font-size: 20px;">
                  <span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(211, 61, 61); background-color: inherit;"
                      >重要提醒：登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                    ></span
                  >
                </div>
                <div>
                  <span
                    >登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                  >
                </div>

                <div>
                  <span
                    >登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                  >
                </div>
                <div>
                  <span
                    ><span
                      style="font-weight: bold; font-size: 20px; color: rgb(211, 61, 61); background-color: inherit;"
                      >重要提醒：登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                    ></span
                  >
                </div>
                <div
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >4.登錄後會出現安全認證，記得點擊「其他選項」和「不要升級」如下圖</span
                    ></span
                  >
                </div>
                <div>
                  <img
                    alt=""
                    src="@/assets/images/ios/iOS144.jpg"
                    style="width: 604px;"
                  />
                </div>
                <div
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >5.點擊</span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >入「已購項目」，再點擊「小雲朵」去下載</span
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >Shadowrocket</span
                    ></span
                  >
                  <div>
                    <img
                      alt=""
                      src="@/assets/images/ios/yigou.jpg"
                      style="width: 604px;"
                    />
                  </div>
                </div>

                <div
                  data-bulb-node-id="FqNn-1692785419880"
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span data-bulb-node-id="952a-1692785419848"
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >6.下載完成後，請到手機桌面開啟Shadowrocket</span
                    ></span
                  >
                  <div>
                    <img
                      alt=""
                      src="@/assets/images/ios/APPLE2-5.jpg"
                      style="width: 604px;"
                    />
                  </div>
                </div>

                <div
                  data-bulb-node-id="bEV1-1692785419882"
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span data-bulb-node-id="ckAb-1692785419853"
                    ><span
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                      >7.依照下面的紅框操作</span
                    ></span
                  >
                  <div>
                    <img
                      alt=""
                      src="@/assets/images/ios/APPLE2-3.jpg"
                      style="width: 604px;"
                    />
                  </div>
                  <div class="display-4 mt-4 mb-4">订阅信息</div>
                  <div v-if="accounts.length" style="white-space: initial;">
                    <div
                      v-for="account in accounts"
                      :key="account._id"
                      class="sub-item mb-2"
                    >
                      <p class="display-4" style="font-size: 14px;">
                        {{ account.product.title }}
                      </p>
                      <base-button
                        class=" mr-3"
                        size="sm"
                        type="primary"
                        @click="
                          handleCopy(
                            `${subLinks_1}/v1/api/interchangeable/${account.subscription ||
                              account._id}?remarks=${decodeURIComponent(account.product.title)}`,
                            $event
                          )
                        "
                        >点我复制订阅连接</base-button
                      >
                      <!-- <base-button size="sm" type="primary" @click="handleCopy(`${subLinks_2}/v1/api/interchangeable/${account.subscription || account._id }`, $event)" >点我复制订阅连接2</base-button> -->
                      <base-button
                        class=" mr-3"
                        size="sm"
                        type="error"
                        @click="
                          addSub(
                            `${subLinks_1}/v1/api/interchangeable/${account.subscription ||
                              account._id}`
                          )
                        "
                        >一键导入配置订阅</base-button
                      >
                    </div>
                  </div>
                  <div>
                    <img
                      alt=""
                      src="@/assets/images/ios/APPLE2-4.jpg"
                      style="width: 604px;"
                    />
                  </div>
                </div>
                <div
                  data-bulb-node-id="D2Px-1692785419883"
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span data-bulb-node-id="85JE-1692785419857"
                    ><span
                      class="bold font-size color background-color"
                      data-color="#d33d3d"
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(211, 61, 61); background-color: rgb(255, 204, 203);"
                      >重要：成功後記得登回自己的Apple ID</span
                    ></span
                  >
                  <div>
                    <div><div></div></div>
                  </div>
                </div>
                <div
                  data-bulb-node-id="X1D3-1692785419884"
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span data-bulb-node-id="BZtH-1692785419859"
                    ><span
                      class="bold font-size color background-color"
                      data-color="#d33d3d"
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(211, 61, 61); background-color: rgb(255, 204, 203);"
                      >重要：成功後記得登回自己的Apple ID</span
                    ></span
                  >
                  <div>
                    <div><div></div></div>
                  </div>
                </div>
                <div
                  data-bulb-node-id="JwQJ-1692785419885"
                  style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
                >
                  <span data-bulb-node-id="OKEo-1692785419861"
                    ><span
                      class="bold font-size color background-color"
                      data-color="#d33d3d"
                      style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(211, 61, 61); background-color: rgb(255, 204, 203);"
                      >重要：成功後記得登回自己的Apple ID</span
                    ></span
                  >
                </div>
              </div>
            </div>
            <!-- <div v-else>
              <h2 class="display-4" style="font-size: 1.2rem">
                你还没有套餐，
                <router-link :to="{ name: 'dashboard-plan' }"
                  >立即购买</router-link
                >
              </h2>
            </div> -->
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import { encode } from 'js-base64'
import clip from '@/utils/clipboard'
import Modal from '@/components/Modal.vue'
import AppleContent from '@/components/AppleContent.vue'
import { fetchAppleidShadowrocket } from '@/api/appleid'
import Tabs from '@/components/Tabs/Tabs.vue'
import TabPane from '@/components/Tabs/TabPane.vue'

export default {
  components: {
    Tabs,
    TabPane,
    Modal,
    AppleContent
  },
  data() {
    return {
      loading: false,
      appleinfo: '',
      modal: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_2
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
    this.getAppid()
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    },
    getAppid() {
      this.loading = true
      fetchAppleidShadowrocket().then(res => {
        this.appleinfo = res.data
        this.loading = false
      })
    },
    addSub(link) {
      // shadowrocket://add/sub://aHR0cHM6Ly96dmt2aXdueS5kb2dneWdvLnRvcDo4NDQzL2FwaS92MS9jbGllbnQvNGMzOGU5YWZlMjRlMWEyMjEzNDc3ZjViZDJmMDYzNjk/ZmxhZz1zaGFkb3dyb2NrZXQ=?remark=%E7%8B%97%E7%8B%97%E5%8A%A0%E9%80%9F.com
      location.href = `shadowrocket://add/sub://${encode(
        link
      )}?remarks=Lue%20Ying`
    }
  }
}
</script>
<style>
.search-noresults img {
  max-width: 100%;
}
.appid {
  font-size: 14px;
}
.appid-hd {
  font-weight: bold;
  color: #333;
  display: inline-block;
  width: 80px;
}
.appid-account {
  line-height: 1.4;
  font-weight: bold;
  color: #333;
  margin-bottom: 6px;
}
.description {
  background-color: #efefef;
  border-radius: 4px;
  padding: 4px;
  box-shadow: 1px 3px 1px rgba(0, 0, 0, 0.01);
}
.item-pas,
.item-id {
  font-weight: bold;
  margin: 0;
  padding-left: 12px;
}

.mytable1 {
  width: 100%;
  margin: 0 auto;
}
.myTr1 {
  width: 100%;
  height: 38px;
  margin: 0 auto;
  display: flex;
}
.myTr1 div {
  padding: 5px 0 0 5px;
  flex: 1;
  height: 100%;
  border-top: 2px #acacac solid;
  border-left: 2px #acacac solid;
}
.mytdRight {
  border-right: 2px #acacac solid;
}
.myButtom {
  border-bottom: 2px #acacac solid;
}
.entry-wrapper span {
  font-weight: bold;
}
/** iframe样式 */
#iframeContain {
  width: 100%;
  height: 400px;
}
</style>
